export class JsonRequestBody {
    readonly headers: Record<string, string>;
    readonly body: string;

    constructor(payload: unknown) {
        this.headers = { 'Content-Type': 'application/json' };
        this.body = JSON.stringify(payload);
    }

    static from(payload: unknown): JsonRequestBody {
        return new JsonRequestBody(payload);
    }
}